const zh = {
    home: '首页',
    product: '产品介绍',
    brand: '品牌动态',
    about: '关于我们',
    ioofox: '云狐游戏',
    searchContent: '搜索内容',
    search: '搜索',
    ioofoxPlatform: '云狐游戏开放平台',
    application: '应用软件',
    brandDynamic: '品牌动态',
    noData: '暂无数据',
    downloads: '用户下载量',
    ranking: '绑定天数',
}
export default zh;


// WEBPACK FOOTER //
// ./src/language/zh.js